import { Observable, throwError, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export interface RetryStrategyOptions {
    maxRetryAttempts?: number;
    scalingDuration?: number;
    excludedStatusCodes?: number[];
}

export function genericRetryStrategy({
    maxRetryAttempts = 3,
    scalingDuration = 1000,
    excludedStatusCodes = []
}: RetryStrategyOptions = {}) {
    return (attempts: Observable<any>) => {
        return attempts.pipe(
            mergeMap((error, i) => {
                const retryAttempt: number = i + 1;
                // if maximum number of retries have been met
                // or response is a status code we don't wish to retry, throw error
                if (retryAttempt > maxRetryAttempts || excludedStatusCodes.find(e => e === error.status)) {
                    return throwError(error);
                }
                return timer(retryAttempt * scalingDuration);
            })
        );
    };
}
